// eslint-disable-next-line
import { getUser, getMe, updateMe } from "@/api/index";

import { omit } from 'lodash';

export default {
  namespaced: true,
  state: {
    /* = data */
    currentTab: 'permissions',
    companyType: {
      company_type: '',
      company_type_id: 0,
      deleted: false,
      description: '',
      time_created: '',
      time_updated: '',
      isEdit: false,
    },
    facilityType: {
      facility_type: '',
      facility_type_id: 0,
      deleted: false,
      description: '',
      time_created: '',
      time_updated: '',
      isEdit: false,
    },
    user: {},
    loadingUserData: false,
    loading: {
      updateData: false,
      userData: false,
    },
  },

  getters: {
    /* = Computed properties, perfects to filter data an execute some calculation */

    // Notifications
    getEmailNotifications(state) {
      if (state.notifications.length > 0) {
        const tempArray = state.notifications.filter((item) => item.notification.type == "EMAIL");
        return tempArray.sort((a, b) => a.notification.orden - b.notification.orden);
      }
      return [];
    },
    getPushNotifications(state) {
      if (state.notifications.length > 0) {
        const tempArray = state.notifications.filter((item) => item.notification.type == "PUSH");
        return tempArray.sort((a, b) => a.notification.orden - b.notification.orden);
      }
      return [];
    },
  },

  mutations: {
    /* Mutations are responsible to change the state */
    setCurrentTab(state, tab) {
      state.currentTab = tab;
    },

    setUser(state, user) {
      state.user = user;
    },

    setLoading(state, loading) {
      state.loading = {
        ...state.loading,
        ...loading,
      };
    },

    setCompanyType(state, companyType) {
      console.log('STATE', state, companyType);
      state.companyType = companyType;
    },
    setFacilityType(state, facilityType) {
      console.log('STATE', state, facilityType);
      state.facilityType = facilityType;
    },
    // Notifications
  },

  actions: {
    /* = Methods */
    // User
    setCompanyType({ commit }, companyType) {
      commit('setCompanyType', companyType);
    },

    setFacilityType({ commit }, facilityType) {
      commit('setFacilityType', facilityType);
    },

    apiGetUser(context, userId) {
      getUser(userId).then((res) => {
        context.commit(
          "setUser",
          omit(res, ["deleted", "time_created", "time_updated", "logo_url", "golf_courses", "user_type", "photo_url", "type_id"])
        );
      });
    },
    apiGetMe(context) {
      getMe().then((res) => {
        context.commit(
          "setUser",
          omit(res, ["deleted", "time_created", "time_updated", "logo_url", "golf_courses", "user_type", "type_id"])
        );
      });
    },

    async apiUpdateMe({ commit, state }, userNewPhoto) {
      commit("setLoading", {
        userData: true,
      });
      await updateMe(state.user, true)
        .then(async (user) => {
          commit("setUser", user);
        })
        .finally(() => {
          commit("setLoading", { userData: false });
        });
    },
  },
};
